import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 10px;

  width: ${({ width }) => width || "80vw"};
  max-width: ${({ maxWidth }) => maxWidth || "95vw"};
  max-height: ${({ maxHeight }) => maxHeight || "95vh"};

  display: flex;
  flex-direction: column;

  /* important */
  height: auto;
  overflow: hidden;

  transition: width 0.2s ease, height 0.2s ease;
`;

export const Header = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #eee;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;

  font-size: 2.5rem;
  line-height: 1;
  cursor: pointer;

  color: #666;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #000;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    outline-offset: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 16px 20px;

  /* this is the magic */
  overflow-y: auto;
`;

export const Footer = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
`;
